<!-- eslint-disable max-lines -->
<!-- eslint-disable max-lines-per-function -->
<template>
    <div class="opportunityApproval-detail-Wrap" v-loading="loading">

        <div class="fixedBox">
            <div class="title">
                商机落标审批
            </div>
            <div class="btnBox">
                <lots-button
                    size="mini"
                    type="primary"
                    @click="submitMip('ruleForm')"
                    v-if="mipUrl && ![7].includes(mipStatus)"
                >
                    mip提交
                </lots-button>

                <!-- 暂存按钮 -->
                <el-button
                    type="primary"
                    @click="saveOpera"
                >
                    暂存
                </el-button>

                <el-button
                    type="primary"
                    @click="lookOpera"
                >
                    查看商机详情
                </el-button>
            </div>
        </div>

        <div class="formBox">
            <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="96px"
                class="ruleForm"
            >
                <el-collapse v-model="collapseActiveNames">
                    <el-collapse-item name="1" class="pd0">
                        <template slot="title"><label class="el-collapse-custom-title">基础信息</label></template>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item label="项目编码：" prop="projectCode" label-width="186px">
                                    <span
                                        :title="ruleForm.projectCode"
                                        class="ellipsis-text"
                                    >
                                        {{ ruleForm.projectCode || '-'  }}
                                    </span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="项目名称：" prop="projectName"  label-width="135px">
                                    <span
                                        :title="ruleForm.projectName"
                                        class="ellipsis-text"
                                    >
                                        {{ ruleForm.projectName || '-'  }}
                                    </span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="商机编码：" prop="opportunityCode"  label-width="186px">
                                    <span
                                        :title="ruleForm.opportunityCode"
                                        class="ellipsis-text"
                                    >
                                        {{ ruleForm.opportunityCode || '-'  }}
                                    </span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="商机名称：" prop="opportunityName">
                                    <span
                                        :title="ruleForm.opportunityName"
                                        class="ellipsis-text"
                                    >
                                        {{ ruleForm.opportunityName || '-'  }}
                                    </span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="客户名称：" prop="customerName" label-width="186px">
                                    <span
                                        :title="ruleForm.customerName"
                                        class="ellipsis-text"
                                    >
                                        {{ ruleForm.customerName || '-'  }}
                                    </span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="商机大类：" prop="businessType"  label-width="135px">
                                    <span
                                        :title="ruleForm.businessType"
                                        class="ellipsis-text"
                                    >
                                        {{ businessTypeChange(ruleForm.businessType) }}
                                    </span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="业务场景：" prop="businessScenario"  label-width="186px">
                                    <span
                                        :title="ruleForm.businessScenario"
                                        class="ellipsis-text"
                                    >
                                        {{ ruleForm.businessScenario || '-'  }}
                                    </span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="分公司：" prop="companyName">
                                    <span
                                        :title="ruleForm.companyName"
                                        class="ellipsis-text"
                                    >
                                        {{ ruleForm.companyName || '-'  }}
                                    </span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="行业大类：" prop="industry" label-width="186px">
                                    <span
                                        :title="ruleForm.industry"
                                        class="ellipsis-text"
                                    >
                                        {{ ruleForm.industry || '-'  }}
                                    </span>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="签单计划（万）：" prop="money" label-width="135px">
                                    <span
                                        :title="ruleForm.money"
                                        class="ellipsis-text"
                                    >
                                        {{ ruleForm.money || '-'  }}
                                    </span>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="开发人所属部门营管：" prop="managerName" label-width="186px">
                                    <span
                                        style="color: #4285F5;cursor: pointer;"
                                        v-if="ruleForm.managerName"
                                        @click="openAssigneeOpera"
                                    >
                                        {{ ruleForm.managerName  }}
                                    </span>
                                    <lotsButton
                                        v-else
                                        type="primary"
                                        icon="el-icon-user"
                                        size="mini"
                                        title="选择开发人所属部门营管"
                                        @click="openAssigneeOpera"
                                    >
                                        选择开发人所属部门营管
                                    </lotsButton>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="落标定性：" prop="reason" label-width="186px">
                                    <el-select
                                        v-model="ruleForm.reason"
                                        placeholder="请选择落标定性"
                                        style="width: 100%;"
                                        :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"
                                    >
                                        <el-option
                                            v-for="item in reasonOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="落标描述：" prop="reasonDesc" label-width="186px">
                                    <el-input
                                        type="textarea"
                                        rows="2"
                                        placeholder="请输入落标描述"
                                        maxlength="500"
                                        show-word-limit
                                        :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"
                                        v-model="ruleForm.reasonDesc"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="ruleForm.reason === 4">
                                <el-form-item label="新商机编码：" prop="newOpportunityCode" label-width="186px">
                                    <lots-md-input
                                        :label="ruleForm.newOpportunityCode"
                                        :config="opportunityOpt"
                                        :cascadeData="ruleForm"
                                        :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"
                                        @change="handleDeptChange($event, opportunityOpt)"
                                    ></lots-md-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="安得投标规模(万)：" prop="bidSize" label-width="186px" :required="isCostReason">
                                    <el-input v-model="ruleForm.bidSize" placeholder="请输入安得投标规模(万)" :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="仓/流量是否能整合：" prop="isIntegrated" label-width="186px" :required="isCostReason">
                                    <el-select
                                        v-model="ruleForm.isIntegrated"
                                        clearable placeholder="请选择"
                                        style="width: 100%;"
                                        :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"
                                    >
                                        <el-option v-for="item in yesNoOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="中标方：" prop="winningBidder" label-width="186px">
                                    <el-input v-model="ruleForm.winningBidder" placeholder="请输入中标方" :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="中标价格(万)：" prop="winningPrice" label-width="186px">
                                    <el-input v-model="ruleForm.winningPrice" placeholder="请输入中标价格(万)" :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="对比现运作价格偏差(万)：" prop="operateDeviation" label-width="186px">
                                    <el-input v-model="ruleForm.operateDeviation" placeholder="请输入对比现运作价格偏差(万)" :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="对比中标方价格偏差(万)：" prop="winningDeviation" label-width="186px">
                                    <el-input v-model="ruleForm.winningDeviation" placeholder="请输入对比中标方价格偏差(万)" :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="安得排名：" prop="anntoRanking" label-width="186px">
                                    <el-input v-model="ruleForm.anntoRanking" placeholder="请输入安得排名" :disabled="mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <el-form-item label="落标复盘分析材料：" prop="loseFlowFile" label-width="186px">
                                    <lots-upload-button
                                        :text="'上传材料'"
                                        :bucket="'annto-lcrm'"
                                        :publicRead="1"
                                        :disabled="ruleForm.loseFlowFile.length > 4 || (mipStatus !== 1 && mipStatus !== 5 && mipStatus !== 6)"
                                        @beforeUpload="beforeUploadUrl"
                                        @callback="(data) => { upLoadFileUrl(data); }"
                                    ></lots-upload-button>
                                    <div class="upload-alert-item" v-for="(item, index) in ruleForm.loseFlowFile" :key="index">
                                        <span :title="item.fileName">{{ item.fileName }}</span>
                                        <i class="el-icon-circle-close" title="删除" @click="delFile(item, index)"></i>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-collapse-item>
                    <el-collapse-item name="2" v-if="mipUrl">
                        <template slot="title"><label class="el-collapse-custom-title">流程信息</label></template>
                        <iframe ref="mipIframe" class="ifr" :src="mipUrl" v-if="mipUrl" />
                    </el-collapse-item>
                </el-collapse>
            </el-form>
        </div>

        <advanceUser ref='advanceUserRef' @confirm="selectUserCallback"></advanceUser>
    </div>
</template>

<script>
import { ref, reactive, onMounted, watch, getCurrentInstance } from '@vue/composition-api';
import { saveApprovalInfo, updateApprovalInfo, getApprovalInfo } from '@/modules/mdm/api/opportunityModules/approval.js';
import { Message } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import lotsMdInput from '@/components/lots/lotsMdInput';
import _ from 'lodash';
import configurl from '@/config/user.env';
import store from '@/store/index';
import lotsButton from '@/components/lots/lotsButton';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import configEnv from '@/config/user.env.js';
import advanceUser from '@/components/lots/otpAdvanceUser';

export default {
    name: 'targetForm',
    components: {
        lotsButton,
        lotsMdInput,
        advanceUser,
        lotsUploadButton
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // 获取Vue实例
        const instance = getCurrentInstance();
        const route = instance ? instance.$route : null;

        const loading = ref(false);
        // 按钮权限
        const authorityCode = reactive(btnAuthority.submissionApplication);
        // 折叠面板
        const collapseActiveNames = ref(['1', '2']);
        // 流程信息iframe地址
        const mipUrl = ref(null);
        // 新商机编码下拉框选项
        const opportunityOption = {
            name: '新商机编码',
            prop: 'opportunityName',
            value: 'opportunityName',
            type: 'advance',
            isFixed: true,
            span: 3,
            advanceConfig: [
                { 'prop': 'opportunityName', 'value': '商机名称' },
                { 'prop': 'opportunityCode', 'value': '商机编码' }
            ],
            tableConfig: [
                { 'prop': 'opportunityCode', 'value': '商机编码' },
                { 'prop': 'opportunityName', 'value': '商机名称', 'displayName': 'opportunityName' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/opportunity/info/page',
            cbParams: ['opportunityCode', 'opportunityName'],
            advanceCode: 'advanceCode'
        };
        // 管理人下拉框选项
        const managerNameOpt = {
            name: '开发人所属部门营管',
            prop: 'managerName',
            value: 'managerName',
            type: 'advance',
            isFixed: true,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusId', 'value': 'ID' },
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusPositionName', 'value': '职位' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/selectUserCompany`,
            cbParams: ['esusUserNameCn#managerName', 'esusLoginName#managerCode'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            }
        };

        // 选择用户回调
        const selectUserCallback = (list) => {
            const user = list?.[0];
            if (user) {
                ruleForm.managerName = user.userName;
                ruleForm.managerCode = user.userCode;
            }
        };

        // 打开选择用户弹窗
        const openAssigneeOpera = (row) => {
            setupContext.refs.advanceUserRef.show();
        };

        // 申请单id
        const applyId = ref('');
        const reasonOptions = ref([]);
        const businessTypeOptions = ref([]);
        const yesNoOptions = ref([]);
        onMounted(() => {
            getDictDataApi({ dictCodes: 'NEOCRM_LOST_REASON_NAME,NEOCRM_BUSINESS_TYPE,NEOCRM_YES_NO' }).then(res => {
                if (+res.code === 0 && res.data?.NEOCRM_LOST_REASON_NAME) {
                    // 将对象 {1: '成本'} 转换为数组 [{label: '成本', value: 1}]
                    reasonOptions.value = Object.entries(res.data?.NEOCRM_LOST_REASON_NAME).map(([value, label]) => ({
                        label,
                        value: Number(value)
                    }));
                }
                if (+res.code === 0 && res.data?.NEOCRM_BUSINESS_TYPE) {
                    // 将对象 {1: '成本'} 转换为数组 [{label: '成本', value: 1}]
                    businessTypeOptions.value = Object.entries(res.data?.NEOCRM_BUSINESS_TYPE).map(([value, label]) => ({
                        label,
                        value: Number(value)
                    }));
                    console.log(businessTypeOptions.value);
                }
                if (+res.code === 0 && res.data?.NEOCRM_YES_NO) {
                    // 将对象 {1: '是'} 转换为数组 [{label: '是', value: 1}]
                    yesNoOptions.value = Object.entries(res.data?.NEOCRM_YES_NO).map(([value, label]) => ({
                        label,
                        value: Number(value)
                    }));
                }
            });
            createMetaNode();
            window.addEventListener('message', messageFunc, false);
            // 重置表单
            setupContext.refs['ruleForm'] && setupContext.refs['ruleForm'].resetFields();
            // 检查URL参数，如果存在id则自动打开对应的详情页
            if (route && route.query.id) {
                applyId.value = route.query.id;
                getDetail().then(res => {
                    // 如果流程信息不存在，则默认自发提交审核
                    if (!res?.flowInfo?.mipId) {
                        sumbitVerify();
                    }
                });
            }
        });

        // 业务类型转换
        const businessTypeChange = (val) => {
            return businessTypeOptions.value.find(item => item.value === val)?.label || '-';
        };

        // 获取详情
        const mipStatus = ref('');
        // 商机id
        const opportunityId = ref('');
        const getDetail = () => {
            return new Promise((resolve) => {
                loading.value = true;
                getApprovalInfo({ id: applyId.value }).then(res => {
                    if (+res.code === 0) {
                        applyId.value = res.data.id;
                        opportunityId.value = res.data?.opportunityId || '';
                        Object.assign(ruleForm, res.data);
                        const { userName, userCode } = store.getters.user;
                        // 流程信息iframe地址
                        mipUrl.value = null;
                        if (res.data?.flowInfo?.mipId) {
                            setTimeout(() => {
                                mipUrl.value = `${configurl.iflowUrl}?fdId=${res.data?.flowInfo?.mipId}&fdTemplateKey=CRM_goal_apply_flow&userCode=${userCode}&userName=${userName}`;
                            }, 100);
                        }
                        mipStatus.value = res.data?.flowInfo?.mipStatus || '';
                        resolve(res.data);
                    }
                }).finally(() => {
                    loading.value = false;
                });
            });
        };

        // 保存操作
        const saveOpera = () => {
            const params = _.cloneDeep(ruleForm);
            if (params.reason && params.reason !== 4) {
                params.newOpportunityCode = null;
            }
            loading.value = true;
            updateApprovalInfo(params).then(res => {
                if (+res.code === 0) {
                    Message.success('暂存成功');
                    // 重置表单
                    setupContext.refs['ruleForm'] && setupContext.refs['ruleForm'].clearValidate();
                    // 等待time毫秒，确保后台更新完成
                    setTimeout(() => {
                        getDetail();
                    }, 100);
                }
            }).finally(() => {
                const time = 1000;
                // 等待time毫秒，确保后台更新完成
                setTimeout(() => {
                    loading.value = false;
                }, time);
            });
        };

        // 保存操作
        const sumbitVerify = () => {
            const params = _.cloneDeep(ruleForm);
            if (params.reason && params.reason !== 4) {
                params.newOpportunityCode = null;
            }
            saveApprovalInfo(params).then(res => {
                if (+res.code === 0) {
                    const time = 1000;
                    // 等待time毫秒，确保后台更新完成
                    setTimeout(() => {
                        getDetail();
                    }, time);
                }
            });
        };

        const updateApprovalAgain = () => {
            // 逻辑很奇怪，但是必须这样写
            const params = _.cloneDeep(ruleForm);
            if (params.reason && params.reason !== 4) {
                params.newOpportunityCode = null;
            }
            loading.value = true;
            updateApprovalInfo(params).then(res => {
                if (+res.code === 0) {
                    // 保留原有逻辑
                    const content = window;
                    content.frames && content.frames.length && content.frames[0]
                        && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
                    // 向当前组件下的 iframe 发送消息
                    const iframe = setupContext.refs['mipIframe'];
                    if (iframe) {
                        iframe.contentWindow.postMessage('mbpm_getApprovalData', mipUrl.value);
                    }
                    currentTime.value = new Date().getTime();
                    store.commit('updateIflowPage', { pageTime: currentTime.value });
                }
            }).finally(() => {
                loading.value = false;
            });
        };

        // eslint-disable-next-line complexity
        const currentTime = ref('');
        const submitMip = async (formName) => {
            setupContext.refs[formName].validate((valid) => {
                if (valid) {
                    if (mipStatus.value === 1 || mipStatus.value === 5 || mipStatus.value === 6) {
                        updateApprovalAgain();
                    } else {
                        // 保留原有逻辑
                        const content = window;
                        content.frames && content.frames.length && content.frames[0]
                            && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
                        // 向当前组件下的 iframe 发送消息
                        const iframe = setupContext.refs['mipIframe'];
                        if (iframe) {
                            iframe.contentWindow.postMessage('mbpm_getApprovalData', mipUrl.value);
                        }
                        currentTime.value = new Date().getTime();
                        store.commit('updateIflowPage', { pageTime: currentTime.value });
                    }
                } else {
                    return false;
                }
            });
        };

        // uat:
        // https://crm-sandbox.xiaoshouyi.com/bff/neoweb#/entityDetail/opportunity/【销售易-商机id】?objectApiKey=opportunity&recordId=【销售易-商机id】&objectId=3&busiTypeId=11010000300001
        // prd:
        // https://annto.my.xiaoshouyi.com/bff/neoweb#/entityDetail/opportunity/【销售易-商机id】?objectApiKey=opportunity&recordId=【销售易-商机id】&objectId=3&busiTypeId=11010000300001
        // 查看操作 - 根据环境跳转商机详情
        const lookOpera = () => {
            const path = '/bff/neoweb#/entityDetail/opportunity/' + opportunityId.value + '?objectApiKey=opportunity&recordId=' + opportunityId.value + '&objectId=3&busiTypeId=11010000300001';
            const jumpUrl = configEnv.xiaoshouyiUrl + path;
            window.open(jumpUrl, '_blank');
        };

        // 新商机编码选择器改变事件
        const handleDeptChange = (data) => {
            ruleForm.newOpportunityName = data.opportunityName;
            ruleForm.newOpportunityCode = data.opportunityCode;
        };

        // 表单数据
        const ruleForm = reactive({
            projectCode: '',
            projectName: '',
            opportunityCode: '',
            opportunityName: '',
            customerName: '',
            businessType: '',
            businessScenario: '',
            companyName: '',
            industry: '',
            money: '',
            reason: '',
            reasonDesc: '',
            newOpportunityCode: '',
            bidSize: '',
            isIntegrated: null,
            winningBidder: '',
            winningPrice: '',
            operateDeviation: '',
            winningDeviation: '',
            anntoRanking: '',
            managerName: '',
            managerCode: '',
            loseFlowFile: []
        });

        // 表单验证规则
        const rules = {
            reasonDesc: [
                { required: true, message: '请输入原因描述', trigger: 'blur' },
                { min: 20, message: '描述至少输入20个字符', trigger: 'blur' }
            ],
            reason: [
                { required: true, message: '请选择落标定性', trigger: 'change' }
            ],
            managerName: [
                { required: true, message: '请选择开发人所属部门营管', trigger: 'change' }
            ],
            newOpportunityCode: [
                { required: true, message: '请选择新商机编码', trigger: 'change' }
            ],
            bidSize: [
                { required: false, message: '请输入安得投标规模(万)', trigger: 'blur' },
                { pattern: /^\d{1,}$/, message: '安得投标规模(万)必须为数字值', trigger: 'blur' }
            ],
            isIntegrated: [
                { required: false, message: '请选择是否整合', trigger: 'change' }
            ],
            winningPrice: [
                { required: false, message: '请输入中标价格(万)', trigger: 'blur' },
                { pattern: /^\d{1,}$/, message: '中标价格(万)必须为数字值', trigger: 'blur' }
            ],
            operateDeviation: [
                { required: false, message: '请输入对比现运作价格偏差(万)', trigger: 'blur' },
                { pattern: /^\d{1,}$/, message: '对比现运作价格偏差(万)必须为数字值', trigger: 'blur' }
            ],
            winningDeviation: [
                { required: false, message: '请输入对比中标方价格偏差(万)', trigger: 'blur' },
                { pattern: /^\d{1,}$/, message: '对比中标方价格偏差(万)必须为数字值', trigger: 'blur' }
            ],
            anntoRanking: [
                { required: false, message: '请输入安得排名', trigger: 'blur' }
            ]
        };

        // 落标定性为"成本"时，bidSize和isIntegrated必填
        const isCostReason = ref(false);
        watch(() => ruleForm.reason, (newVal) => {
            const isRequired = newVal === 1;
            isCostReason.value = isRequired;
            rules.bidSize[0].required = isRequired;
            rules.isIntegrated[0].required = isRequired;
            // 当不为必填时，清除验证状态
            if (!isRequired) {
                ruleForm.bidSize = '';
                ruleForm.isIntegrated = null;
                setupContext.refs['ruleForm'] && setupContext.refs['ruleForm'].clearValidate(['bidSize', 'isIntegrated']);
            }
        });

        // 新商机编码选择器配置
        const opportunityOpt = reactive(opportunityOption);

        // 参数准备辅助函数
        const prepareApproveParams = (eventData) => {
            const { mipId } = ruleForm.flowInfo;
            const { origin, pathname } = window.location;
            const params = eventData.data || {};
            const { tenantCode } = store.getters.currentTenant;
            params.tenantCode = tenantCode;
            params.currentApplicationCode = 'APP201904230047';
            if (params.formParam) {
                const { processParam } = params;
                let isToOtherPersons = '';
                if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                    isToOtherPersons = processParam.toOtherPersons;
                }
                // eslint-disable-next-line max-len
                params.formParam.fdUrl = `${origin}${pathname}#/opportunityApproval?id=${ruleForm.id}&fdId=${mipId}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`;
            }
            return params;
        };

        // approveProcess 回调提取为独立函数，减少嵌套
        const handleApproveProcess = (params) => {
            return approveProcess(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    const time = 1800;
                    // 等待time毫秒，确保后台更新完成
                    setTimeout(() => {
                        getDetail();
                    }, time);
                } else {
                    Message.error(res.msg);
                }
            }).finally(() => {
            });
        };

        // 主流程调度
        const messageFunc = async (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (!(event.data && event.data.data && event.data.success)) return;
            const params = prepareApproveParams(event.data);
            handleApproveProcess(params);
        };

        const createMetaNode = () => {
            const mipmeta = document.getElementById('mipmeta');
            if (mipmeta) {
                return false;
            }
            const meta = document.createElement('meta');
            meta.httpEquiv = 'Content-Security-Policy';
            meta.content = 'upgrade-insecure-requests';
            meta.id = 'mipmeta';
            document.getElementsByTagName('head')[0].appendChild(meta);
        };

        // 上传文件前的回调函数
        const beforeUploadUrl = res => {
        };

        // 上传文件后的回调函数
        const upLoadFileUrl = (res) => {
            if (res && +res.code === 0) {
                ruleForm.loseFlowFile.push({
                    fileUrl: res.data.downUrl,
                    fileName: res.data.name
                });
                setupContext.refs['ruleForm'].clearValidate('loseFlowFile');
            }
        };

        // 删除文件
        const delFile = (item, index) => {
            ruleForm.loseFlowFile.splice(index, 1);
        };

        return {
            collapseActiveNames,
            ruleForm,
            saveOpera,
            lookOpera,
            rules,
            authorityCode,
            handleDeptChange,
            opportunityOpt,
            loading,
            mipUrl,
            submitMip,
            beforeUploadUrl,
            upLoadFileUrl,
            delFile,
            reasonOptions,
            isCostReason,
            mipStatus,
            businessTypeChange,
            managerNameOpt,
            selectUserCallback,
            openAssigneeOpera,
            yesNoOptions
        };
    }
};
</script>

<style lang="less" scoped>
::v-deep .ruleForm {
    .el-tag.el-tag--info,
    .el-input.is-disabled .el-input__inner::placeholder,
    .el-input.is-disabled .el-input__inner {
        color: #606266;
    }
}
::v-deep .pd0 {
    .el-collapse-item__content {
        padding-bottom: 0;
    }
}
::v-deep .upload-alert-item {
    display: flex;
    padding: 0;
    align-items: center;

    span {
        color: #67c23a;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        text-decoration: underline;
        font-size: 14px;
        max-width: 240px;
    }
    .el-icon-circle-close {
        color: #b1b3b0;
        font-size: 16px;
        margin-left: 8px;
        cursor: pointer;

        &:hover {
            background-color: #b1b3b0;
            color: #fff;
            border-radius: 1000px;
        }
    }
}
.ellipsis-text {
    display: inline-block;
    width: 95%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ifr {
    width: 100%;
    height: 100vh;
    border: none;
}
.el-collapse-custom-title {
    color: #606266;
    font-size: 14px;
    font-weight: 600;
}
.opportunityApproval-detail-Wrap {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #fff;
    padding: 20px;

    .fixedBox {
        height: 70px;
    }
    .formBox {
        height: calc(100vh - 238px);
        overflow-y: auto;
    }

    .title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        position: relative;
        text-align: center;

        .addNewAddr {
            position: absolute;
            right: 0;
            top: 0;
        }
    }
}
</style>
